import { render, staticRenderFns } from "./DisplayName.vue?vue&type=template&id=18b815ed"
import script from "./DisplayName.vue?vue&type=script&lang=js"
export * from "./DisplayName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18b815ed')) {
      api.createRecord('18b815ed', component.options)
    } else {
      api.reload('18b815ed', component.options)
    }
    module.hot.accept("./DisplayName.vue?vue&type=template&id=18b815ed", function () {
      api.rerender('18b815ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DisplayName.vue"
export default component.exports